<!-- my-loader.component.html -->
<div class="progress-loader" [hidden]="!loading">
    <div class="loading-spinner">
        <svg class="spinner__svg" viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
            <circle class="spinner__icon" fill="none" stroke-width="3" stroke-miterlimit="10" cx="50" cy="50" r="20"></circle>
        </svg>
    </div>
</div>